import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";

export const productsForm = groupInput({
  supportEnabled: input<boolean>(),
  aiEnabled: input<boolean>(),
  textMessagingEnabled: input<boolean>(),
});

export type ProductsForm = InputSchema.Input<typeof productsForm>;

export type ProductsValue = InputSchema.Value<typeof productsForm>;

export const productsDefault: ProductsValue = {
  supportEnabled: false,
  aiEnabled: false,
  textMessagingEnabled: false,
};

export const ProductsCard = memo(function ProductsCard({
  input,
}: {
  input: ProductsForm;
}) {
  const { supportEnabled, aiEnabled, textMessagingEnabled } = input.inputs;

  return (
    <Card borderRadius="md" title="Products">
      <Flex dir="column" gap="lg">
        <RedoToggle
          description="Enable Customer Support product"
          label="Customer Support"
          setValue={supportEnabled.setValue}
          size="sm"
          value={supportEnabled.value}
        />
        <RedoToggle
          description="Enable AI features for Customer Support and Storefront AI Agent"
          label="AI"
          setValue={aiEnabled.setValue}
          size="sm"
          value={aiEnabled.value}
        />
        <RedoToggle
          description="Enable text messaging and allow the merchant to enroll in billing"
          label="Text messaging"
          setValue={textMessagingEnabled.setValue}
          size="sm"
          value={textMessagingEnabled.value}
        />
      </Flex>
    </Card>
  );
});
